/****   request.js   ****/
// 导入axios
import axios from "axios";
import { Notify } from "vant";
import router from "../router";
import es5 from "mathjs";
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  // baseURL: "https://t-apipxb.yunvip123.com/api",
  // baseURL: "https://apipxb.yunvip123.com/api",
  // 超时时间 单位是ms，这里设置了3s的超时时间
  // timeout: 30 * 1000
});
// 2.请求拦截器
service.interceptors.request.use(
  config => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
    let obj = JSON.parse(localStorage.getItem("token"));
    if (obj) {
      const etmss = obj.etmss;
      const etmsl = obj.etmsl;
      if (
        config.url.indexOf("upAudio") != -1 ||
        config.url.indexOf("upImg") != -1 ||
        config.url.indexOf("upVideo") != -1
      ) {
        config.headers = {
          "Content-Type": "application/x-www-form-urlencoded", //配置请求头
          "etms-s": etmss,
          "etms-l": etmsl
        };
      } else {
        config.headers = {
          "Content-Type": "application/json", //配置请求头
          "etms-s": etmss,
          "etms-l": etmsl
        };
      }
    } else {
      config.headers = {
        "Content-Type": "application/json" //配置请求头
      };
    }
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.slice(1));
      const param1 = params.get("etms");
      if (param1 && param1.length > 9) {
        config.headers["etms-a"] = param1;
      }
    }

    return config;
  },
  error => {
    Notify({
      message: error.message,
      color: "#ad0000",
      background: "#ffe1e1",
      duration: 5000
    });
    Promise.reject(error);
  }
);

// 3.响应拦截器
service.interceptors.response.use(
  response => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    if (
      response.data.code !== "10000" &&
      response.data.code !== "10003" &&
      response.data.code !== "10009" &&
      response.config.url.indexOf("getJsSdkUiPackage") == -1
    ) {
      Notify({
        message: response.data.message,
        color: "#ad0000",
        background: "#ffe1e1",
        duration: 5000
      });
      return false;
    }
    if (response.data.code === "10003") {
      const obj = JSON.parse(localStorage.getItem("token"));
      const s = obj.etmss;
      const l = obj.etmsl;
      let data = {
        strLoginInfo: l,
        strSignature: s
      };
      axios
        .post(
          "https://apipxb.yunvip123.com/api/parent/parentRefreshToken",
          data,
          {
            headers: {
              "Content-Type": "application/json",
              "etms-s": s,
              "etms-l": l
            }
          }
        )
        .then(res => {
          localStorage.setItem(
            "token",
            JSON.stringify({
              etmss: res.data.resultData.s,
              etmsl: res.data.resultData.l
            })
          );
          return Promise.reject(response);
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (response.data.code === "10009") {
      localStorage.removeItem("token");
      localStorage.removeItem("tenantNo");
      router.replace({ path: "/unbindStudent" });
    }
    return response;
  },
  error => {
    /***** 接收到异常响应的处理开始 *****/
    var isTk = false;
    if (error && error.response) {
      // 1.公共错误处理
      // 2.根据响应码具体处理
      error.message = error.response.messag;
      if (error.response.statusText == "Unauthorized") {
        const obj = JSON.parse(localStorage.getItem("token"));
        const s = obj.etmss;
        const l = obj.etmsl;
        let data = {
          strLoginInfo: l,
          strSignature: s
        };
        axios
          .post(
            "https://apipxb.yunvip123.com/api/parent/parentRefreshToken",
            data
          )
          .then(res => {
            localStorage.setItem(
              "token",
              JSON.stringify({
                etmss: res.data.resultData.s,
                etmsl: res.data.resultData.l
              })
            );
          })
          .catch(err => {
            console.log(err);
          });
      }
      if (error.response.status == "401") {
        localStorage.removeItem("token");
        localStorage.removeItem("tenantNo");
        router.replace({ path: "/loginOut" });
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (error.response.data.message === "手机号未注册") {
          Notify({
            message: "手机号未注册，请重新登录",
            color: "#ad0000",
            background: "#ffe1e1",
            duration: 5000
          });
          localStorage.removeItem("token");
          localStorage.removeItem("tenantNo");
          router.replace({ path: "/loginOut" });
        } else {
          Notify({
            message: error.response.data.message,
            color: "#ad0000",
            background: "#ffe1e1",
            duration: 5000
          });
          isTk = true;
        }
      }
    }
    if (!isTk) {
      Notify({
        message: "系统繁忙，请稍后再试",
        color: "#ad0000",
        background: "#ffe1e1",
        duration: 5000
      });
    }

    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);
//4.导入文件
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js